import React, { useContext, useEffect } from 'react'
import {
    Route,
    BrowserRouter as Router,
    withRouter,
    Switch,
    Redirect,
} from 'react-router-dom'
import PrivateRoute from './privateRoute'
// import Dashboard from '@/views/Dashboard'
import Dashboard from '@/views/Dashboard'
import Profile from '@/product/customViews/Profile'
// import Profile from '@/views/Profile'
import CustomerActivity from '../product/customViews/CustomerActivity'
import AuctionLots from '@/views/AuctionLots/dynamic'
import Report from '@/views/Report'
import Login from '@/product/customViews/Login'
import Listing from '@/views/Listing/dynamic'
import Disputes from '@/views/Dispute'
import BidDeposit from '../product/customViews/BidDeposit'
// import UserView from '../product/customViews/UserManagement/dynamic'
import UserView from '../../src/views/UserManagement/dynamic'
import AddUserForm from '../views/UserManagement/AddUserForm'
import Employee from '../product/customViews/EmployeeManagement'
import TemplateView from '@/views/Communications/TemplateView'
import StaticView from '@/views/Settings/StaticView'
import BroadCaster from '../product/customViews/VideoAuction/BroadCaster'
// import Return from '@/views/Return/index'
import Return from '../product/customViews/Return'
import ReturnView from '../product/customViews/Return/view'
import Inventory from '../product/customViews/Inventory'
import QuestionAnswer from '../product/customViews/Comments/index'
import EmailLogs from '../product/views/Communications/EmailLogs'
import Invoice from '@/views/Invoice/index'
import Payment from '../product/customViews/Payment'
import LanguageManager from '@/views/LanguageManager'
import StaticPages from '../product/customViews/Settings/StaticPages'
// import ConfigView from '../product/customViews/Settings/ConfigView'
import ConfigView from '../product/customViews/Settings/ConfigView'
import MaintanenceManage from '../product/views/Settings/Maintanence/MaintanenceManage'
import ChangePassword from '@/product/views/ChangePassword'
import AuthContext from '@/product/context/auth/authContext'
import CustomCommonContext from '../custom/context/common/commonContext'
import ProductCommonContext from '@/product/context/common/commonContext'
import Category from '../product/customViews/Settings/Category'
import Condition from '@/views/Settings/Condition'
import Review from '@/views/Settings/Review'
import Schedulepickup from '../product/customViews/SchedulePickUp/index'

import Location from '../product/customViews/Settings/Location'
import OrgView from '@/views/Organization/OrgView'
import CreateCampaign from '../product/customViews/Campaign/CreateCampaign'
import EmailTemplate from '../product/customViews/Campaign/EmailTemplate'
import Wallet from '../product/customViews/Wallet'
import SubscribeData from '../product/customViews/subscribe'
// import TransactionPayment from '../product/customViews/Transaction/payment'
import TransactionRefund from '../product/customViews/Transaction/refund'
import Appointment from '../product/customViews/Appointment'
import BidIncrement from '../product/customViews/Settings/BidIncrement'
import LiveAuction from '../product/customViews/VideoAuction/LiveAuction'
import SettingsUI from '../product/customViews/SettingsUI'
import DynamicPage from '@/views/Dynamic/pages'
import TaxCodeList from '../product/customViews/Settings/TaxCodeList'
import DynamicTablePages from '@/product/views/DynamicTable/pages'
import Message from '@/views/Message'

import Order from '../product/customViews/Order'
import ERP from '../product/customViews/ERP'
import InventoryErp from '@/product/customViews/ERP/Inventory'
import Manifest from '@/product/customViews/ERP/Manifest'
import Plugins from '@/product/views/Plugins'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import PalletPricing from '../product/customViews/Settings/PalletPricing'
// import MyCard from '../product/customViews/MyPayments/MyCards'
import AuctionTemplates from '../product/customViews/Template/Auction/dynamic'
import ProductTemplates from '../product/customViews/Template/Product/dynamic'
import BannerImage from '../product/customViews/Settings/BannerImage'
import TwoFactor from '../product/customViews/Settings/TwoFactor'
import BillingInfo from '../product/views/MyPayments'
import MyInvoice from '../product/views/MyInvoice'
import EditListing from '@/views/Listing/EditListing'
import AuditTrialListing from '@/views/AuditTrail'
// import InvoiceView from '../product/customViews/Invoice/view'
import InvoiceView from '@/views/Invoice/view.js'
import ProductTemplateManage from '../product/customViews/Template/Product/dynamicListing'
import Logs from '../product/customViews/Logs'
import ManageComments from '../product/customViews/Comments/manageComments'
import EmployeeView from '../product/customViews/EmployeeManagement/edit'
import AuctionTemplateManage from '../product/customViews/Template/Auction/dynamicListing'
import EmployeeEdit from '@/views/EmployeeManagement/edit'
import EmployeeManage from '@/views/EmployeeManagement/view'
import OrgManage from '@/views/Organization/OrgManage'
import UserManage from '@/views/UserManagement/dynamicUser'
import InitialPublicFunction from '@/product/views/InitialFunction/public'
import AuctionListing from '@/views/AuctionLots/dynamicListing'
import Theme from '../product/customViews/Store/Theme'
import ListingManage from '@/views/Listing/dynamicListing'
import AddListingManage from '@/views/Listing/AddDynamicListing'
import AgencyView from '@/product/customViews/AgencyManagement'
import AllAgencyUsers from '@/product/customViews/AgencyManagement/AgencyUsers'
import AgencyPayment from '@/product/customViews/AgencyManagement/payment'
import SchedulePickUp from '@/product/customViews/SchedulePickUp'
import PaymentManage from '@/product/customViews/Invoice/PaymentManage'
import ForgotPassword from '@/product/customViews/ForgotPassword'
import ResetPassword from '@/product/customViews/ResetPassword'
import Cigars from '../views/Cigars'
import Country from '../views/Country'
import DisapprovalReasonList from '@/views/DisapprovalReasonList'
import FactoryCode from '../views/FactoryCode'
import SerialNumber from '@/views/SerialNumber'
import InitialFunction from '@/product/views/InitialFunction'
import UserCards from '@/product/customViews/UserManagement/UserCards'
import Coupon from '@/product/customViews/Coupon'
import SellerWithdrawalRequest from '@/views/SellerWithdrawalRequest'
import Faq from '@/views/Settings/Faq'
import PaymentUploadFile from '@/views/PaymentUploadFile/paymentUploadFile'
import TransactionPayment from '@/views/Transaction/payment.js'
import Configurations from '@/views/Settings/Configuration/Configuration'
import CurrencyConfig from '@/views/CurrencyConfig/index'
import FxRates from '@/views/FxRates'
const Routes = () => {
    const { loadUser, isAuthenticated } = useContext(AuthContext)
    const { getAllCountries, getAllStates } = useContext(ProductCommonContext)
    const { getGlobalVariable } = useContext(CustomCommonContext)
    const { getAllDynamicFields, getAllDynamicTables } =
        useContext(DynamicContext)

    useEffect(() => {
        loadUser()
    }, [])

    return (
        <>
            <InitialPublicFunction
                global={true}
                countries={true}
                states={true}
                cities={false}
            />
            {isAuthenticated ? <InitialFunction /> : null}
            <Switch>
                <PrivateRoute
                    exact
                    path="/registration_coupon"
                    component={Coupon}
                />
                <Route exact path="/" component={Login} />
                <Route
                    exact
                    path="/forgot_password"
                    render={(props) => (
                        <ForgotPassword
                            {...props}
                            onSuccess={true}
                            onError={true}
                        />
                    )}
                    // component={ForgotPassword}
                    // onSuccess={true}
                    // onError={true}
                />
                <Route
                    exact
                    path="/reset_password/:token"
                    component={ResetPassword}
                />
                <PrivateRoute exact path="/db/cigars" component={Cigars} />
                <PrivateRoute
                    exact
                    path="/db/factory_code"
                    component={FactoryCode}
                />
                <PrivateRoute
                    exact
                    path="/db/disapproval_reason"
                    component={DisapprovalReasonList}
                />
                <PrivateRoute
                    exact
                    path="/db/payment_file"
                    component={PaymentUploadFile}
                />
                <PrivateRoute
                    exact
                    path="/db/serial_number"
                    component={SerialNumber}
                />
                <PrivateRoute exact path="/db/country" component={Country} />
                <PrivateRoute
                    exact
                    path="/change_password"
                    component={ChangePassword}
                />
                <PrivateRoute exact path="/profile">
                    <Profile customValidation={false} formatPhone={false} />
                </PrivateRoute>
                <PrivateRoute exact path="/dashboard" component={Dashboard} />
                <PrivateRoute
                    exact
                    path="/auction/:action"
                    component={AuctionLots}
                />
                <PrivateRoute exact path="/payment" component={Payment} />
                <PrivateRoute exact path="/wallet" component={Wallet} />
                <PrivateRoute exact path="/report" component={Report} />
                <PrivateRoute exact path="/disputes" component={Disputes} />
                <PrivateRoute
                    exact
                    path="/listing/:action"
                    component={Listing}
                />
                {/* <PrivateRoute exact path="/all/products" component={Listing} /> */}
                <PrivateRoute
                    exact
                    path="/agency/:action"
                    component={AgencyView}
                />
                <PrivateRoute
                    exact
                    path="/agency/users/all"
                    component={AllAgencyUsers}
                />
                <PrivateRoute
                    exact
                    path="/agency/payment"
                    component={AgencyPayment}
                />
                <PrivateRoute
                    exact
                    path="/templates/auction"
                    component={AuctionTemplates}
                />
                <PrivateRoute
                    exact
                    path="/templates/listing"
                    component={ProductTemplates}
                />
                <PrivateRoute
                    exact
                    path="/users/:action"
                    component={UserView}
                />
                <PrivateRoute exact path="/adduser" component={AddUserForm} />
                <PrivateRoute exact path="/settings/faq" component={Faq} />
                <PrivateRoute
                    exact
                    path="/employees/:action"
                    component={Employee}
                />
                <PrivateRoute exact path="/logs/:action" component={Logs} />
                <PrivateRoute
                    exact
                    path="/communications/:action"
                    component={TemplateView}
                />
                <PrivateRoute
                    exact
                    path="/withdrawal_request"
                    component={SellerWithdrawalRequest}
                />
                <PrivateRoute
                    exact
                    path="/languageManager"
                    component={LanguageManager}
                />
                <PrivateRoute
                    exact
                    path="/site_configuration"
                    component={Configurations}
                />
                <PrivateRoute
                    exact
                    path="/currency_configuration"
                    component={CurrencyConfig}
                />
                <PrivateRoute exact path="/fixed_rate" component={FxRates} />

                <PrivateRoute exact path="/store/themes" component={Theme} />
                <PrivateRoute
                    exact
                    path="/store/configuration"
                    component={Theme}
                />
                {/* <PrivateRoute
                    exact
                    path="/invoice/:action"
                    component={Invoice}
                /> */}
                <PrivateRoute exact path="/invoice/:action">
                    <Invoice from={'invoice'} full_payment={true} />
                </PrivateRoute>
                <PrivateRoute
                    exact
                    path="/billing/:action"
                    component={MyInvoice}
                />
                <PrivateRoute
                    exact
                    path="/ordercontrol/:action"
                    component={Order}
                />
                <PrivateRoute
                    exact
                    path="/settings/static"
                    component={StaticView}
                />
                <PrivateRoute
                    exact
                    path="/settings/general"
                    component={ConfigView}
                />
                <PrivateRoute
                    exact
                    path="/settings/maintanence"
                    component={MaintanenceManage}
                />
                <PrivateRoute
                    exact
                    path="/settings/category"
                    component={Category}
                />
                <PrivateRoute
                    exact
                    path="/activity"
                    component={CustomerActivity}
                />
                <PrivateRoute
                    exact
                    path="/management/source"
                    component={Condition}
                />
                <PrivateRoute
                    exact
                    path="/management/review"
                    component={Review}
                />
                <PrivateRoute exact path="/erp" component={ERP} />
                <PrivateRoute
                    exact
                    path="/erp/inventory"
                    component={InventoryErp}
                />
                <PrivateRoute exact path="/erp/manifest" component={Manifest} />
                <PrivateRoute
                    exact
                    path="/settings/location"
                    component={Location}
                />
                <PrivateRoute exact path="/return/:action" component={Return} />
                <PrivateRoute
                    exact
                    path="/settings/bid_increments"
                    component={BidIncrement}
                />
                <PrivateRoute
                    exact
                    path="/transaction/payment"
                    component={TransactionPayment}
                />
                <PrivateRoute
                    exact
                    path="/transaction/refund"
                    component={TransactionRefund}
                />
                <PrivateRoute exact path="/org/:action" component={OrgView} />
                <PrivateRoute
                    exact
                    path="/campaign/create"
                    component={CreateCampaign}
                />
                <PrivateRoute
                    exact
                    path="/campaign/template"
                    component={EmailTemplate}
                />
                <PrivateRoute exact path="/messages" component={Message} />
                <PrivateRoute
                    exact
                    path="/inventory/:action"
                    component={Inventory}
                />
                <PrivateRoute
                    exact
                    path="/bid_deposit"
                    component={BidDeposit}
                />
                <PrivateRoute
                    exact
                    path="/videoAuction/broadcast"
                    component={BroadCaster}
                />
                <PrivateRoute
                    exact
                    path="/billing/:type/:id"
                    component={BillingInfo}
                />
                {/* <PrivateRoute
                    exact
                    path="/payments/saved_cards"
                    component={MyCard}
                /> */}
                <PrivateRoute
                    exact
                    path="/videoAuction/live_auction"
                    component={LiveAuction}
                />
                <PrivateRoute
                    exact
                    path="/ui_settings"
                    component={SettingsUI}
                />
                <PrivateRoute
                    exact
                    path="/dynamic/pages"
                    component={DynamicPage}
                />
                <PrivateRoute
                    exact
                    path="/dynamic/table/pages"
                    component={DynamicTablePages}
                />
                <PrivateRoute
                    exact
                    path="/appointment/:action"
                    component={Appointment}
                />
                <PrivateRoute
                    exact
                    path="/erp/auction/:action"
                    component={ERP}
                />
                <PrivateRoute
                    exact
                    path="/erp/:id"
                    permissionGroup="/erp"
                    component={ERP}
                />
                <PrivateRoute
                    exact
                    path="/schedulepickup"
                    component={Schedulepickup}
                />
                <PrivateRoute
                    exact
                    path="/subscribers"
                    component={SubscribeData}
                />
                <PrivateRoute
                    exact
                    path="/settings/tax_code"
                    component={TaxCodeList}
                />
                <PrivateRoute
                    exact
                    path="/settings/palletPricing"
                    component={PalletPricing}
                />
                <PrivateRoute exact path="/plugins" component={Plugins} />
                <PrivateRoute
                    exact
                    path="/settings/banner"
                    component={BannerImage}
                />
                <PrivateRoute
                    exact
                    path="/settings/twoFactor"
                    component={TwoFactor}
                />
                <PrivateRoute
                    exact
                    path="/questions_answers"
                    component={QuestionAnswer}
                />
                <PrivateRoute
                    exact
                    path="/listing/edit/:id"
                    permissionGroup="/listing"
                    component={EditListing}
                />
                <PrivateRoute
                    exact
                    path="/audit_trail/:id"
                    permissionGroup="/listing"
                    component={AuditTrialListing}
                />
                <PrivateRoute
                    exact
                    path="/listing/:status/:id"
                    permissionGroup="/listing"
                    component={ListingManage}
                />
                <PrivateRoute
                    exact
                    path="/add/product"
                    component={AddListingManage}
                />
                <PrivateRoute
                    exact
                    path="/auction/:status/:id"
                    permissionGroup="/auction"
                    component={AuctionListing}
                />
                <PrivateRoute
                    exact
                    path="/invoice/view/:id/:uid"
                    permissionGroup="/invoice"
                    component={InvoiceView}
                />
                <PrivateRoute
                    exact
                    path="/invoice/payment/:id/:uid"
                    permissionGroup="/invoice"
                >
                    <PaymentManage
                        from={'invoice'}
                        data={{ id: 0, sid: 0, status: 'edit' }}
                        full_payment={true}
                        defaultCountry
                    />
                </PrivateRoute>
                <PrivateRoute
                    exact
                    path="/employees/edit/:eid"
                    permissionGroup="/employees"
                    component={EmployeeEdit}
                />
                <PrivateRoute
                    exact
                    path="/templates/listing/:status/:id"
                    permissionGroup="/templates/listing"
                    component={ProductTemplateManage}
                />
                <PrivateRoute
                    exact
                    path="/templates/auction/:status/:id"
                    permissionGroup="/templates/auction"
                    component={AuctionTemplateManage}
                />
                <PrivateRoute
                    exact
                    path="/questions_answers/:id/:productId"
                    permissionGroup="/questions_answers"
                    component={ManageComments}
                />
                <PrivateRoute
                    exact
                    path="/employees/new/:eid"
                    permissionGroup="/employees"
                    component={EmployeeManage}
                />
                <PrivateRoute
                    exact
                    path="/return/view/:id/:uid"
                    permissionGroup="/return"
                    component={ReturnView}
                />
                <PrivateRoute
                    exact
                    path="/seller/:status/:id"
                    permissionGroup="/org"
                    component={OrgManage}
                />
                <PrivateRoute
                    exact
                    path="/user/:status/:id"
                    permissionGroup="/users"
                    component={UserManage}
                />
                <PrivateRoute
                    exact
                    path="/user/payment/cards/:id"
                    permissionGroup="/users"
                    component={UserCards}
                />
                <Route path="*">
                    <Redirect to="/dashboard" />
                </Route>
            </Switch>
        </>
    )
}
export default withRouter(Routes)
